import { useNavigate } from 'react-router';
import { WorkOrdersList } from '../components/WorkOrdersList';

export default function JobsPage() {
  const navigate = useNavigate();

  return <WorkOrdersList onNavigateToDetail={(orderId) => navigate(`/jobs/${orderId}`)} />;
}
